export default __webpack_public_path__ + "static/media/img_illust02.9e7ee513.png";